import { c as _c } from "react/compiler-runtime";
import { HOTEL_DETAILS_ACTIVE_TAB, HOTEL_DETAILS_MODAL } from "@website/accommodation-ui/constant/keys";
import { TourCardPropertiesType } from "@website/accommodation-ui/tour-card";
import { hotelButtons } from "@website/accommodation-ui/tour-card/tour-card-hotel/tour-card-hotel-furthermore/schema";
import { TourCardHotelFurthermoreDrawer } from "@website/accommodation-ui/tour-card/tour-card-hotel/tour-card-hotel-furthermore/tour-card-hotel-furthermore-drawer";
import { TabType } from "@website/accommodation-ui/tour-card/tour-card-hotel/tour-card-hotel-furthermore/types";
import { useViewPort } from "@website/hooks/viewport";
import { addEventToWebengage } from "@website/tracking/tracking.webengage";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { FC } from "react";
export const TourCardHotelFurthermore: FC<TourCardPropertiesType> = properties => {
  const $ = _c(46);
  const {
    hotel,
    pricing,
    isDomestic
  } = properties;
  let t0;
  if ($[0] !== pricing) {
    t0 = pricing || {};
    $[0] = pricing;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    priceOff
  } = t0;
  let t1;
  if ($[2] !== hotel) {
    t1 = hotel || {};
    $[2] = hotel;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    name,
    stars,
    id
  } = t1;
  const router = useRouter();
  const {
    isDesktop
  } = useViewPort();
  const t2 = router.query[HOTEL_DETAILS_MODAL];
  let t3;
  if ($[4] !== id) {
    t3 = id.toString();
    $[4] = id;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const open = t2 === t3;
  let handleSelectTab;
  let onClose;
  let t4;
  let t5;
  if ($[6] !== id || $[7] !== isDesktop || $[8] !== isDomestic || $[9] !== name || $[10] !== priceOff || $[11] !== router || $[12] !== stars) {
    const visibleHotelButtons = isDomestic ? hotelButtons : hotelButtons.filter(_temp);
    let t6;
    if ($[17] !== id || $[18] !== name || $[19] !== priceOff || $[20] !== router || $[21] !== stars) {
      t6 = tab => {
        router.replace({
          query: {
            ...router.query,
            [HOTEL_DETAILS_MODAL]: id,
            [HOTEL_DETAILS_ACTIVE_TAB]: tab.key
          }
        }, undefined, {
          shallow: true,
          scroll: false
        });
        if (tab.webengageEventName) {
          addEventToWebengage(tab.webengageEventName, {
            HotelName: name,
            HotelStars: stars,
            TotalPrice: priceOff
          });
        }
      };
      $[17] = id;
      $[18] = name;
      $[19] = priceOff;
      $[20] = router;
      $[21] = stars;
      $[22] = t6;
    } else {
      t6 = $[22];
    }
    handleSelectTab = t6;
    let t7;
    if ($[23] !== id || $[24] !== isDesktop || $[25] !== router) {
      t7 = tab_0 => {
        router?.[isDesktop ? "replace" : "push"]({
          query: {
            ...router.query,
            [HOTEL_DETAILS_MODAL]: id,
            [HOTEL_DETAILS_ACTIVE_TAB]: tab_0.key
          }
        }, undefined, {
          shallow: true,
          scroll: false
        });
      };
      $[23] = id;
      $[24] = isDesktop;
      $[25] = router;
      $[26] = t7;
    } else {
      t7 = $[26];
    }
    const openDrawer = t7;
    let t8;
    if ($[27] !== router) {
      t8 = () => {
        router.replace({
          query: omit(router.query, [HOTEL_DETAILS_MODAL, HOTEL_DETAILS_ACTIVE_TAB])
        }, undefined, {
          shallow: true,
          scroll: false
        });
      };
      $[27] = router;
      $[28] = t8;
    } else {
      t8 = $[28];
    }
    onClose = t8;
    t4 = "border-t-outline-thin grid grid-cols-3 border-t px-4 pb-[6px] pt-[10px] md:mb-3 md:flex md:flex-1 md:items-end md:gap-4 md:border-t-0 md:py-0";
    let t9;
    if ($[29] !== openDrawer) {
      t9 = (tab_1, index) => <button key={index} className={`text-secondary text-caption md:text-subtitle-2 min-w-max cursor-pointer font-medium ${index === 1 ? "max-md:text-center" : index === 2 ? "max-md:text-end" : "max-md:text-start"}`} onClick={() => openDrawer(tab_1)} type="button">{tab_1.btnNameCard}</button>;
      $[29] = openDrawer;
      $[30] = t9;
    } else {
      t9 = $[30];
    }
    t5 = visibleHotelButtons.map(t9);
    $[6] = id;
    $[7] = isDesktop;
    $[8] = isDomestic;
    $[9] = name;
    $[10] = priceOff;
    $[11] = router;
    $[12] = stars;
    $[13] = handleSelectTab;
    $[14] = onClose;
    $[15] = t4;
    $[16] = t5;
  } else {
    handleSelectTab = $[13];
    onClose = $[14];
    t4 = $[15];
    t5 = $[16];
  }
  let t6;
  if ($[31] !== t4 || $[32] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  const t7 = `fixed right-0 top-0 z-30 h-screen w-screen ${open ? "block" : "hidden"}`;
  let t8;
  if ($[34] !== onClose || $[35] !== t7) {
    t8 = <div className={t7} onClick={onClose} />;
    $[34] = onClose;
    $[35] = t7;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  let t9;
  if ($[37] !== handleSelectTab || $[38] !== onClose || $[39] !== open || $[40] !== properties) {
    t9 = <TourCardHotelFurthermoreDrawer isOpen={open} onClose={onClose} onSelectTab={handleSelectTab} {...properties} />;
    $[37] = handleSelectTab;
    $[38] = onClose;
    $[39] = open;
    $[40] = properties;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  let t10;
  if ($[42] !== t6 || $[43] !== t8 || $[44] !== t9) {
    t10 = <>{t6}{t8}{t9}</>;
    $[42] = t6;
    $[43] = t8;
    $[44] = t9;
    $[45] = t10;
  } else {
    t10 = $[45];
  }
  return t10;
};
function _temp(t) {
  return t.key !== "review";
}